<template>
<div class="chapter">
<div class="inner_page">
<h1 class="fronttitle SC">Prologue</h1>
<p class="left ">He is running, running, running.</p>
<p class="follow">And it’s like no kind of running he’s ever run before. He’s the surge that burst the dam and he’s pouring down the hillslope, channelling through the grass to the width of his widest part. He’s tripping into hoof-rucks. He’s slapping groundsel stems down dead. Dandelions and chickweed, nettles and dock.</p>
<p class="follow">This time, there’s no chance for sniff and scavenge and scoff. There are no steel bars to end his lap, no chain to jerk at the limit of its extension, no bellowing to trick and bully him back. This time, he’s further than he’s ever seen before, past every marker along the horizon line, every hump and spork he learned by heart.</p>
<p class="follow">It’s the season of digging out. It’s a day of soft rain. There’s wind enough to tilt the slimmer trunks off kilter and drizzle enough to twist the long hairs on his back to a mop of damp curls. There’s blood enough to gush into his beard and spatter his front paws as they rise and plunge. And there’s a hot, wet thing bouncing against his neck. It’s the size of a snailshell and it makes a dim squelch each time it strikes. It’s attached to some gristly tether dangling from some leaked part of himself, but he cannot make out the what nor the where of it.</p>
<p class="follow">Were he to stop, were he to examine the hillslope and hoof-rucks and groundsel and dandelions and chickweed and nettles and dock, he’d see how the breadth of his sight span has been reduced by half and shunted to his right side, how the left is pitch black until he swivels his head. But he doesn’t stop, and notices only the cumbersome blades, the spears of rain, the upheaval of tiny insects and the blood spilling down the wrong side of his coat, the outer when it ought to be the inner.</p>
<p class="follow">He is running, running, running. And there’s no course or current to deter him. There’s no impulse from the root of his brain to the roof of his skull which says other than <span class="smallcaps">RUN</span>.</p>
<p class="follow">He is One Eye now.</p>
<p class="follow">He is on his way.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front03.vue?34dbd072